import { Injectable, inject } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { RawXmlResponse } from '../../../interfaces/response/AdminPageResponses';
import { RawXmlDataAdapter } from '../../../classes/adapters/response/admin/RawXmlDataAdapter.service';

/**
 * This service communicates with backend to handle itrent debugging data.
 */
@Injectable({
  providedIn: 'root'
})
export class ItrentDebugService {
  private http = inject(HttpClient);
  private rawXmlDataAdapter = inject(RawXmlDataAdapter);

  url = environment.apiUrl + '/itrent';

  getRawResponseForEmployee(employeeId: string): Observable<string> {
    const url = `${this.url}/employee/${employeeId}`;
    return this.http.get(url).pipe(
      map((data: RawXmlResponse) => this.rawXmlDataAdapter.adapt(data)));
  }

  getRawResponseForPosition(positionId: string): Observable<string> {
    const url = `${this.url}/position/${positionId}`;
    return this.http.get(url).pipe(
      map((data: RawXmlResponse) => this.rawXmlDataAdapter.adapt(data)));
  }

  getRawResponseForAbsences(employeeId: string, fromDate: string, toDate: string): Observable<string> {
    const url = `${this.url}/employee/${employeeId}/absences/${fromDate}/${toDate}`;
    return this.http.get(url).pipe(
      map((data: RawXmlResponse) => this.rawXmlDataAdapter.adapt(data)));
  }

  getRawResponseForDailyPatterns(employeeId: string, fromDate: string, toDate: string): Observable<string> {
    const url = `${this.url}/employee/${employeeId}/daily-patterns/${fromDate}/${toDate}`;
    return this.http.get(url).pipe(
      map((data: RawXmlResponse) => this.rawXmlDataAdapter.adapt(data)));
  }
}
